import { render, staticRenderFns } from "./tablePermissionPossession.vue?vue&type=template&id=6216503f&"
import script from "./tablePermissionPossession.vue?vue&type=script&lang=js&"
export * from "./tablePermissionPossession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports